<template>
  <ol class="pp-steps" aria-label="Setup progress">
    <template v-for="(label, i) in steps">
      <li
        :key="label"
        class="pp-step"
        :class="{ 'pp-done': i + 1 < current, 'pp-on': i + 1 === current }"
        :aria-current="i + 1 === current ? 'step' : null"
      >
        <span class="pp-num">{{ current > i + 1 ? '✓' : i + 1 }}</span>
        {{ label }}
      </li>
      <span
        v-if="i < steps.length - 1"
        :key="`${label}-line`"
        class="pp-line"
        :class="{ 'pp-done': i + 1 < current }"
      />
    </template>
  </ol>
</template>

<script>
import { PostPurchaseSteps } from '../constants/PostPurchase';

// "How much you hand to Bambee → Choose your plan → Bambee installation".
// `current` is 1-based; earlier steps show a check.
export default {
  name: 'PostPurchaseSteps',
  props: {
    current: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return { steps: PostPurchaseSteps };
  },
};
</script>

<style src="../assets/postPurchase.css"></style>
